import { ref, computed } from "vue";
import useApi from "@/services/useApi";
import { useStore } from "vuex";

export default function useActivationWhatsapp() {
    const { api, reactiveHeaders } = useApi();
    const store = useStore();

    const activationStatus = ref("");
    const payloadLinkActivationWhatsapp = ref({}); // {description, status, ?data: {link}}
    const statusNumberActivation = ref("");

    const headersState = computed(() => {
        console.debug(222, store.getters["auth/getAuthHeader"]);
        return store.getters["auth/getAuthHeader"];
    });

    const initiateActivationWhatsapp = async (number) => {
        const strNumber = number || "";
        let result;

        await api
            .post(
                "/api/activation/whatsapp",
                { number: strNumber },
                { headers: headersState.value }
            )
            .then((response) => {
                result = response.data;
                return response.data;
            })
            .catch((error) => {
                result = error.response?.data;
            })
            .finally(() => {
                switch (result?.description) {
                    case "Something went wrong":
                        activationStatus.value = "oops";
                        break;
                    case "Number activated":
                        activationStatus.value = "activated";
                        break;
                    case "Pending number activation":
                    case "Activation process initiated":
                    case "Pending link generation":
                        activationStatus.value = "generationCode";
                        break;
                    default:
                        activationStatus.value = result.description;
                        break;
                }
            });
    };

    const getLinkActivationWhatsapp = (number) => {
        const strNumber = number ? String(number) : "";
        let result = "";
        return api
            .post(
                "/api/activation/whatsapp/link",
                { number: strNumber },
                { headers: headersState.value }
            )
            .then((response) => {
                result = response.data;
                if (result?.data?.link) {
                    store.commit("activation/SET_QR_LINK", result.data.link);
                }
                payloadLinkActivationWhatsapp.value = "scanCode";
                return result;
            })
            .catch((error) => {
                const result = error.response?.data;
                const desc = result?.description;
                switch (desc) {
                    case "Pending link generation":
                        payloadLinkActivationWhatsapp.value = "generationCode";
                        break;
                    case "Number activated":
                        store.commit(
                            "activation/SET_NUMBER",
                            result.data.number
                        );
                        payloadLinkActivationWhatsapp.value = "activated";
                        break;
                    case "Number requires activation":
                        payloadLinkActivationWhatsapp.value = "timeOver";
                        break;
                    case "Something went wrong":
                    default:
                        payloadLinkActivationWhatsapp.value = "oops";
                        break;
                }
                return result;
            });
    };
    const getStatusActivationWhatsapp = async (number) => {
        await api
            .post(
                "/api/activation/whatsapp/status",
                { number },
                { headers: headersState.value }
            )
            .then((response) => {
                if (response.data.status === "Error") {
                    statusNumberActivation.value = "oops";
                } else
                    switch (response.data.description) {
                        case "Number requires activation":
                            statusNumberActivation.value = "timeOver";
                            break;
                        case "Pending link generation":
                            if (store.state.activation.qrLink) {
                                statusNumberActivation.value = "oops";
                            }
                            break;
                        case "Number activated":
                            statusNumberActivation.value = "activated";
                            break;
                        case "Pending number activation":
                            //  отрабатывает на этапе генерации кода БЕЗ пушера
                            if (!store.state.activation.qrLink) {
                                getLinkActivationViber(number);
                            } else statusNumberActivation.value = "scanCode";
                            break;
                        case "Something went wrong":
                        default:
                            statusNumberActivation.value = "oops";
                            break;
                    }
                return statusNumberActivation.value;
            })
            .catch((error) => {
                console.error("Error getStatusActivationViber ", error);
                statusNumberActivation.value = "oops";
            });
    };

    return {
        initiateActivationWhatsapp,
        activationStatus,
        getLinkActivationWhatsapp,
        payloadLinkActivationWhatsapp,
        getStatusActivationWhatsapp,
        statusNumberActivation,
    };
}
